import { useEffect, useMemo } from 'react';
import { GroupsService, GroupSettingsResponse } from 'src/services/groups';
import { useGeneralStore } from 'src/store';

const COLOR_VAR_MAP: Array<[keyof GroupSettingsResponse['settings']['colors'], string]> = [
  ['denary', '--color-denary'],
  ['nonary', '--color-view-btn'],
  ['senary', '--color-border'],
  ['primary', '--color-primary'],
  ['quinary', '--color-text'],
  ['octonary', '--color-view-section'],
  ['tertiary', '--destructive'],
  ['secondary', '--color-profile-wellcome'],
  ['septenary', '--color-border-select'],
  ['quaternary', '--color-error'],
];

function applyCssVariables(colors: GroupSettingsResponse['settings']['colors']) {
  const root = document.documentElement;
  COLOR_VAR_MAP.forEach(([apiKey, cssVar]) => {
    const value = colors[apiKey];
    if (value) root.style.setProperty(cssVar, value);
  });
}

export function useBranding() {
  const setSiteConfig = useGeneralStore((s) => s.setSiteConfig);
  const setIsLoadingConfig = useGeneralStore((s) => s.setIsLoadingConfig);

  const groupHash = useMemo(() => {
    if (typeof document === 'undefined') return null;
    return document.querySelector('meta[name="x-group-hash"]')?.getAttribute('content');
  }, []);

  useEffect(() => {
    if (!groupHash) {
      setIsLoadingConfig(false);
      return;
    }
    let cancelled = false;
    (async () => {
      try {
        const group = await GroupsService.getByHash(groupHash);
        if (cancelled) return;
        // store non-color settings in siteConfig for UI usage
        setSiteConfig({
          logo: group.settings?.images?.logo || '',
          theme: 'theme-default',
          welcomeTitle: group.settings.texts?.welcomeTitle || '',
          welcomeDescription: group.settings.texts?.welcomeText || '',
          images: group.settings.images || null,
          emails: group.settings.emails || null, 
          phones: group.settings.phones || null,
        });
        // apply CSS variables at runtime
        applyCssVariables(group.settings.colors);
      } catch (e) {
        // silent fail to avoid blocking app
        // console.warn('Branding load failed', e);
      } finally {
        if (!cancelled) {
          setTimeout(() => setIsLoadingConfig(false), 200);
        }
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [groupHash, setSiteConfig, setIsLoadingConfig]);
}


